import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchCustomsLinkUserToken } from '../../../common/api';

export const loadTokenForBookingNo = createAsyncThunk(
  'load-customs-link-token',
  async (bookingNo: number) => {
    return fetchCustomsLinkUserToken(bookingNo);
  },
);
